import GATSBY_COMPILED_MDX from "/codebuild/output/src4200471458/src/documentation-v2/content/doc/guides/using_the_paystack_checkout_in_a_mobile_webview.mdx";
import * as React from 'react';
import {Link, graphql} from 'gatsby';
import {MDXProvider} from '@mdx-js/react';
import Layout from '../components/Layout/Layout';
import CardContainer from '../components/Cards/CardContainer';
import ApiLink from '../components/ApiLink/ApiLink';
import ExternalLink from '../components/ExternalLink/ExternalLink';
import Card from '../components/Cards/Card';
import DemoCard from '../components/Cards/DemoCard';
import TestCard from '../components/TestCard/TestCard';
import TestAccount from '../components/TestAccount/TestAccount';
import TestMoMo from '../components/TestMoMo/TestMoMo';
import CardLinks from '../components/CardLinks/CardLinks';
import RepoCard from '../components/RepoCard/RepoCard';
import UnorderedList from '../components/List/UnorderedList';
import OrderedList from '../components/List/OrderedList';
import Callout from '../components/Callout/Callout';
import CommunityLibrary from '../components/CommunityLibrary/CommunityLibrary';
import Tabs from '../components/Tabs/Tabs';
import TabsMulti from '../components/Tabs/TabsMulti';
import RequestResponse from '../components/RequestResponse/RequestResponse';
import {Code} from '../components/Code';
import BetaH1 from '../components/BetaH1/BetaH1';
import './doc-template.scss';
const DocTemplate = ({data: {mdx}, children}) => {
  const {tableOfContents, fields, frontmatter} = mdx;
  const shortcodes = {
    Link,
    CardContainer,
    ApiLink,
    Card,
    DemoCard,
    ExternalLink,
    TestCard,
    TestAccount,
    TestMoMo,
    CardLinks,
    RepoCard,
    UnorderedList,
    OrderedList,
    Callout,
    CommunityLibrary,
    Tabs,
    TabsMulti,
    RequestResponse,
    BetaH1,
    pre: props => React.createElement(Code, {
      props: props
    })
  };
  return React.createElement("div", null, React.createElement(Layout, {
    title: frontmatter.title
  }, tableOfContents, React.createElement(MDXProvider, {
    components: shortcodes
  }, children), fields));
};
export const query = graphql`
	query docBySlug($slug: String!) {
		mdx(fields: { slug: { eq: $slug } }) {
			tableOfContents
			fields {
				slug
			}
			frontmatter {
				title
			}
		}
	}
`;
DocTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(DocTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
